import React from "react";
import ChatSidebar from "../Components/ChatSidebar";
export default function Messages() {
    return (
        <div>
            <ChatSidebar />
        </div>
    )
}